import React from "react";
import styled from "styled-components";

import FrameCollection1 from "../../../../../assets/images/Event-2026/FrameCollection1.png";
import FrameCollection2 from "../../../../../assets/images/Event-2026/FrameCollection2.png";
import FrameCollection3 from "../../../../../assets/images/Event-2026/FrameCollection3.png";
import FrameMission from "../../../../../assets/images/Event-2026/FrameMission.png";
import Bid from "../../../../../assets/images/Event-2026/bid.png";
import Coin from "../../../../../assets/images/Event-2026/popup-coin.png";
import CoinGold from "../../../../../assets/images/Event-2026/crown1.png";
import FrameMission2 from "../../../../../assets/images/Event-2026/FrameMission2.png";
import FrameMission3 from "../../../../../assets/images/Event-2026/FrameMission3.png";
import BuyBid from "../../../../../assets/images/Event-2026/BID1.png";
import Subscribe from "../../../../../assets/images/Event-2026/Subscribe.png";
import IconCheck from "../../../../../assets/images/Event-2026/iconV.svg";
import { Button } from "antd";
import { useQuery } from 'react-query';
import { getMiniGameMissionsQuery } from 'dataLayer/miniGame';
import { useNavigate } from '@hooks/useNavigate';
import { useTranslation } from 'react-i18next';

const specialPackages = [
  "CHANCE10",
  "SUBASTA_WEEKLY",
  "SUBASTA_MONTHLY",
];

const background1 = [
  "CHANCE",
  "CHANCE2",
  "CHANCE5",
  "CHANCE10",
];

const background2 = [
  "SUBASTA_DAILY",
  "SUBASTA_WEEKLY",
  "SUBASTA_MONTHLY",
];

const Items = ({ type, item }) => {
  const navigate = useNavigate();
  const { t } = useTranslation()

  const showSuperCoin = specialPackages.includes(item?.package);

  const handleClick = () => {
    if (item?.completed === 0) {
      navigate(item.link);
    }
  };

  return (
    <div className="list">
      <div
        className={`item ${type === "daily" ? "item-daily" : type === "weekly" ? "item-weekly" : "item-subscribe"}`}
      >
        <div className="item-content_top">
          <div className="item-content_top-bid">
            <img src={type === "daily" ? Bid : type === "weekly" ? BuyBid : Subscribe} alt="" />
            <span
              className={
                type === "daily" ? "item-content_top-bid-text" : "item-content_top-bid-text_2"
              }
            >
              {item?.name || ''}
            </span>
          </div>
          <Button
            onClick={handleClick}
            className={`item-content-top_btn ${item?.completed === 0 ? 'execute' : 'completed'}`}
          >
            {item?.completed === 0 ? t('execute') :
              <>
                <img src={IconCheck} alt="image" className='icon-completed' />
                {t('completed')}
              </>}
          </Button>
        </div>
        {type === "daily" ? (
          <Button className="item-content-bottom_btn item-content-bottom_btn_daily">
            <img src={Coin} alt="" />
            +{item.normal_coin} {t('Coins')}
          </Button>
        ) : (
          <Button
            className={`item-content-bottom_btn ${type === "weekly" ? "item-content-bottom_btn_weekly" : "item-content-bottom_btn_subscribe"} ${!showSuperCoin ? "has-super-coin" : ""}`}
          >
            <div>
              <img src={Coin} alt="" />
              +{item.normal_coin} {t('Coins')}
            </div>

            {showSuperCoin && (
              <>
                <div className="line" />
                <div className="reward-item-right">
                  <img src={CoinGold} alt="" />
                  <span>+{item.supper_coin} {t('super_coins')}</span>
                </div>
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

const Titles = ({ text }) => {
  return <h5 className="mission-title">{text}</h5>;
};

export default function MissionsListCollection() {
  const { t } = useTranslation()

  const { data } = useQuery(
    getMiniGameMissionsQuery()
  );


  return (
    <Container>
      <div className="frame-container">
        <div className="frame-top">
          <h3 className="title">{t('mission_to_earn_coins')}</h3>
        </div>

        <div className="frame-middle">
          <div className="prize-grid-content">
            <div className="daily-mission-conllection">
              <Titles text={t('daily_mission')} />
              <div className="list-product">
                {
                  data
                    ?.filter(item => item.type === 1)
                    ?.map((item, index) => (
                      <Items
                        key={item.id + index}
                        item={item}
                        type="daily"
                      />
                    ))
                }
              </div>
            </div>
            <div className="more-mission-conllection">
              <Titles text={t('more_mission')} />
              <div className="list-product">
                {
                  data
                    ?.filter(
                      item =>
                        item.type === 2 &&
                        background1.includes(item.package)
                    )
                    ?.map(item => (
                      <Items
                        key={item.id}
                        item={item}
                        type="weekly"
                      />
                    ))
                }
                {
                  data
                    ?.filter(
                      item =>
                        item.type === 2 &&
                        background2.includes(item.package)
                    )
                    ?.map(item => (
                      <Items
                        key={item.id}
                        item={item}
                        type="subscribe"
                      />
                    ))
                }
              </div>
            </div>
          </div>
        </div>
        <div className="frame-bottom" />
      </div>
      <p className="super-coin-info">{t('super_coin_will_open_a_random_piece_of_super_prizes')}</p>
    </Container>
  );
}

const Container = styled.div`
  .frame-container {
    width: 100%;
    max-width: 1200px;
    margin: auto;
  }
  .super-coin-info {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 100px;
    font-size: 18px;
    color: #ffffff;
    text-shadow:
      -2px -2px 0 #013f97,
      2px -2px 0 #013f97,
      -2px 2px 0 #013f97,
      2px 2px 0 #013f97,
      0px -2px 0 #013f97,
      0px 2px 0 #013f97,
      -2px 0px 0 #013f97,
      2px 0px 0 #013f97;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
  .mission-title {
    color: #a6baff;
    font-size: 20px;
    font-weight: 800;
    margin: 0 40px 10px 40px;
    text-transform: uppercase;
    @media (max-width: 768px) {
      font-size: 16px;
      margin: 0 20px 10px 20px;
    }
  }
  .list {
    padding: 0 40px;
    @media (max-width: 768px) {
      padding: 0 20px;
    }
  }
  .item {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: auto;
    padding: 20px 40px;
    /* margin: 20px 0; */
    @media (max-width: 768px) {
      height: auto;
      padding: 15px;
      margin: 10px 0;
    }
  }
  .item-daily {
    background-image: url(${FrameMission});
  }
  .item-weekly {
    background-image: url(${FrameMission2});
  }
  .item-subscribe {
    background-image: url(${FrameMission3});
  }

  .item-content-bottom_btn {
    padding: 10px 20px;
    height: 100%;
    max-height: 55px;
    width: 100%;
    border: none;
    outline: none;
    border-radius: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #fff;
    @media (max-width: 768px) {
      font-size: 14px;
      max-height: 47px;
      padding: 10px 6px;
    }
    img {
      width: 35px;
      height: 35px;
      margin-right: 30px;
      @media (max-width: 768px) {
        width: 30px;
        height: 30px;
        margin-right: 5px;
      }
    }
    @media (max-width: 360px) {
      font-size: 12px;
    }
    @media (max-width: 375px) {
      font-size: 12px;
    }
  }
  .item-content-bottom_btn_daily {
    background: linear-gradient(100deg, #1f209a 0%, #3e42d5 100%);
  }
  .item-content-bottom_btn_weekly {
    background: linear-gradient(100deg, #7682d3 0%, #93a6f1 100%);
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    gap: 20px;
    position: relative;
    width: 100%;
    max-width: 100%;

    @media (max-width: 768px) {
      gap: 5px;
      justify-content: space-between;
    }
    .reward-item-right {
      span {
        color: #fffb00;
      }
    }
  }
  .item-content-bottom_btn_subscribe {
    background: linear-gradient(100deg, #de9023 0%, #f1b662 100%);
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    gap: 20px;
    width: 100%;
    max-width: 100%;
    
    @media (max-width: 768px) {
      gap: 5px;
      justify-content: space-between;
    }
    position: relative;
    .reward-item-right {
      span {
        color: #fffb00;
      }
    }
  }
  .item-content-bottom_btn_subscribe::after,
  .item-content-bottom_btn_weekly::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 8px;
    bottom: 8px;
    width: 1px;
    background: #fff;
    transform: translateX(-50%);
    @media (max-width: 768px) {
         left: 45%;
    }
  }
  .has-super-coin::after,
  .has-super-coin::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 8px;
    bottom: 8px;
    width: 1px;
    background: transparent;
    transform: translateX(-50%);
     @media (max-width: 768px) {
         left: 45%;
    }
  }

  .has-super-coin{
    justify-content: space-around;
  }
  
  .item-content_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;

    .item-content-top_btn {
      border: none;
      outline: none;
      border-radius: 5px;
      background: linear-gradient(180deg, rgba(217, 96, 20, 1) 0%, rgba(254, 145, 4, 1) 100%);
      width: 100%;
      max-width: 220px;
      height: 100%;
      padding: 10px 20px;
     
      span{
        font-weight: 700;
        font-size: 16px;
        color: #fff;
      }

       .icon-completed{
            height: 20px;
            width: 20px;
            margin-right: 5px;
            margin-bottom: 5px;
          }

      @media (max-width: 768px) {
        max-width: 120px;
      }
    }
    .completed{
			background: linear-gradient(
					180deg,
					rgba(30, 163, 23, 1) 0%,
					rgba(25, 184, 16, 1) 100%
				);
        @media (max-width: 768px) {
          max-width: 160px;
        }
		  }
      .execute{
        background: linear-gradient(
            180deg,
            rgba(217, 96, 20, 1) 0%,
            rgba(254, 145, 4, 1) 100%
          );	
         
      }

    .item-content_top-bid {
      display: flex;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        @media (max-width: 768px) {
          width: 40px;
          height: 40px;
        }
      }
      .item-content_top-bid-text {
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        margin-left: 10px;
        @media (max-width: 768px) {
          font-size: 14px;
        }
        @media (min-width: 768px) and (max-width: 1024px) {
          font-size: 15px;
        }

        @media (min-width: 834px) and (max-width: 1194px) {
          font-size: 16px;
        }

        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 16px;

        }
      }
      .item-content_top-bid-text_2 {
        color: #162481;
        font-size: 20px;
        font-weight: 700;
        margin-left: 10px;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: break-word;

        @media (max-width: 768px) {
          font-size: 14px;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
          max-width: 140px;
          display: inline-block;
        }
        @media (min-width: 768px) and (max-width: 1024px) {
          font-size: 15px;
        }

        @media (min-width: 834px) and (max-width: 1194px) {
          font-size: 16px;
        }

        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 16px;

        }
      }
    }
  }

  /* TOP */
  .frame-top {
    background-image: url(${FrameCollection1});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 115px;
    position: relative;
      @media (max-width: 768px) {
        height: 75px;
      }
  }

  .title {
    color: rgba(253, 221, 16, 1);
    font-size: 25px;
    line-height: 27px;
    font-weight: 800;
    text-transform: uppercase;

    position: absolute;
    top: 40px;
    left: 70px;
    margin: 0;
    @media (max-width: 768px) {
      font-size: 13px;
      line-height: 18px;
      left: 25px;
      top: 27px;
    }
  }

  /* MIDDLE */
  .frame-middle {
    background-image: url(${FrameCollection2});
    background-repeat: repeat-y;
    background-size: 100% 100%;
    height: 100%;
    min-height: 900px;
  }

  .prize-grid-content {
    box-sizing: border-box;
    color: #fff;
    .list-product{
      display: flex;
      flex-direction: column;
      gap: 20px;
      @media (max-width: 768px) {
        gap: 10px;
      }
    }
  }

  /* BOTTOM */
  .frame-bottom {
    background-image: url(${FrameCollection3});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 40px;
  }
`;
